import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Button from '../Button/Button';
export default function CopyCodeButton({ copied, ...others }) {
    return (_jsx(Button, { type: "button", theme: copied ? 'success' : 'primary', ...others, children: copied ? 'Copied to clipboard' : 'Copy to clipboard' }));
}
